import { getAppEnv, waitForAppEnvInit } from '../../env/browser/env.js';
import { GenericError } from '../../errors/shared/genericError.js';
import { UnknownError } from '../../errors/shared/base.js';
import { createBaseStdoutLogger } from './baseStdoutLogger.js';

const NAMESPACE = 'core.logger';
function createLazyContextLogger(name, opts = {}) {
    const { waitForContext = true } = opts;
    const logger = createBaseStdoutLogger(name, opts);
    import('./logger.js')
        .then(({ makeContextTransport }) => {
        const appEnv = getAppEnv();
        if (appEnv.isErr()) {
            logger.debug(appEnv.Err);
            if (waitForContext) {
                // TODO: Потенциально здесь могут быть утечки памяти. К моменту инициализации appEnv
                // logger может уже не использоваться (то есть должен быть удален из памяти)
                waitForAppEnvInit(() => {
                    logger.setTransport(makeContextTransport(getAppEnv().unwrap(), name, opts));
                });
            }
        }
    })
        .catch(err => {
        logger.error(GenericError.isLike(err)
            ? err
            : new UnknownError({
                message: 'Ошибка при загрузке модуля core/logger',
                domain: NAMESPACE + '.lazy-context-logger',
                details: err,
            }));
    });
    return logger;
}

export { createLazyContextLogger };
//# sourceMappingURL=lazyLogger.js.map
